import t from "../locales";

export default function SurveyNavigation({ onPreviousPage }) {
  return (
    <div className="survey__actions">
      <button className="button button--outline" onClick={onPreviousPage}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentcolor"
          className="icon button__icon"
        >
          <path d="M10 18L11.4 16.55L7.85 13H20V11H7.85L11.4 7.45L10 6L4 12L10 18Z" />
        </svg>
        {t("general.prevPage")}
      </button>
      <button type="submit" className="button">
        {t("general.nextPage")}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentcolor"
          className="icon button__icon"
        >
          <path d="M14 18L12.6 16.55L16.15 13H4V11H16.15L12.6 7.45L14 6L20 12L14 18Z" />
        </svg>
      </button>
    </div>
  );
}
